import _extends from "/home/node/app/node_modules/next/node_modules/@babel/runtime/helpers/esm/extends";
import _classCallCheck from "/home/node/app/node_modules/next/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/node/app/node_modules/next/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/home/node/app/node_modules/next/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/home/node/app/node_modules/next/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/home/node/app/node_modules/next/node_modules/@babel/runtime/helpers/esm/inherits";
var __jsx = React.createElement;
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import React, { Component } from 'react';
import Slider from 'react-slick';
import Link from 'next/link';
import { HowTileSlickSettings } from "../DirectContentForm/DirectMemberUtils";
import { HowItWorksArrowButton, HowItWorksBannerContainer, HowItWorksFlow, HowItWorksHeader, HowItWorksIconContainer, HowItWorksIconsContainer, HowItWorksInfo, HowItWorksLogo, HowItWorksSubHeader, HowItWorksSubHeaderGroup, HowItWorksText, HowItWorksTextGroup, HowItWorksWrapper, NextIcon } from "./style.js";
var HowItWorksBanner = /*#__PURE__*/function (_Component) {
  function HowItWorksBanner(props) {
    var _this;
    _classCallCheck(this, HowItWorksBanner);
    _this = _callSuper(this, HowItWorksBanner, [props]);
    _this.next = _this.next.bind(_this);
    _this.previous = _this.previous.bind(_this);
    return _this;
  }
  _inherits(HowItWorksBanner, _Component);
  return _createClass(HowItWorksBanner, [{
    key: "next",
    value: function next() {
      this.slider.slickNext();
    }
  }, {
    key: "previous",
    value: function previous() {
      this.slider.slickPrev();
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      var HowItWorksTiles = function HowItWorksTiles(_ref) {
        var next = _ref.next,
          rightIcon = _ref.rightIcon,
          image = _ref.image,
          copy = _ref.copy,
          title = _ref.title,
          isContrastIcon = _ref.isContrastIcon,
          joinNowLink = _ref.joinNowLink;
        return __jsx(HowItWorksWrapper, null, __jsx(HowItWorksFlow, null, !rightIcon && __jsx(HowItWorksIconsContainer, null, __jsx(HowItWorksIconContainer, {
          isContrastIcon: isContrastIcon
        }, __jsx(HowItWorksLogo, {
          src: image,
          alt: title
        }))), rightIcon && __jsx(HowItWorksIconsContainer, null, __jsx(HowItWorksIconContainer, {
          showRightArrow: true,
          isContrastIcon: isContrastIcon
        }, __jsx(HowItWorksLogo, {
          src: image,
          alt: title
        })), __jsx(HowItWorksArrowButton, {
          onClick: next
        }, __jsx(NextIcon, {
          src: rightIcon,
          alt: title
        })))), __jsx(HowItWorksInfo, null, __jsx(HowItWorksSubHeaderGroup, null, __jsx(HowItWorksSubHeader, null, title)), __jsx(HowItWorksTextGroup, null, __jsx(HowItWorksText, null, copy, "\xA0", joinNowLink && __jsx(Link, {
          href: joinNowLink
        }, __jsx("a", null, "Join here"))))));
      };
      return __jsx(HowItWorksBannerContainer, {
        wideView: true
      }, __jsx(HowItWorksHeader, null, "Simply follow the steps below"), __jsx(Slider, _extends({}, HowTileSlickSettings, {
        ref: function ref(arg) {
          _this2.slider = arg;
        }
      }), this.props.banners.map(function (content, i) {
        var howLogo = content.howLogo,
          howCopy = content.howCopy,
          howTitle = content.howTitle,
          rightIcon = content.rightIcon,
          joinNowLink = content.joinNowLink;
        return __jsx(HowItWorksTiles, {
          key: i,
          image: howLogo,
          copy: howCopy,
          title: howTitle,
          rightIcon: rightIcon,
          next: _this2.next,
          isContrastIcon: _this2.props.isContrastIcon,
          joinNowLink: joinNowLink
        });
      })));
    }
  }]);
}(Component);
HowItWorksBanner.defaultProps = {
  isContrastIcon: false
};
export default HowItWorksBanner;